module.exports = __webpack_public_path__ + "img/main.3688c3a1.jpg";